import { checkOggSupport, decodeBase64EncodedBuffer } from './loader';
import { SamplePlayer } from './SamplePlayer';
export class SoundFontPlayer extends SamplePlayer {
    buffers;
    mode;
    constructor(audioContext, buffers, mode) {
        super(audioContext);
        this.buffers = buffers;
        this.mode = mode;
        this.buffers = buffers;
    }
    play = (note, gain, when) => {
        const buffer = this.buffers.get(note);
        if (buffer == undefined) {
            console.warn(`No note ${note} in soundfont`, 'warning');
        }
        else {
            return this._play(buffer, when, gain);
        }
    };
    static async loadName(name, audioContext, root) {
        const hasOggSupport = await checkOggSupport(audioContext);
        const url = hasOggSupport ? `${root}/ogg/${name}-ogg.js` : `${root}/mp3/${name}-mp3.js`;
        return SoundFontPlayer.loadUrl(url, audioContext, hasOggSupport ? 'ogg' : 'mp3');
    }
    static async loadUrl(url, audioContext, mode) {
        try {
            const data = await SoundFontPlayer.fetchData(url);
            const decoder = pitchDecoder(audioContext);
            const buffers = await Promise.all(Object.entries(data).map(decoder));
            return new SoundFontPlayer(audioContext, new Map(buffers), mode);
        }
        catch (e) {
            throw new Error(`Cannot load ${url}: ${e}`);
        }
    }
    static async fetchData(url) {
        const response = await fetch(url);
        if (response.status - response.status % 100 !== 200) {
            throw new Error(`Cannot load soundfont ${url}. Status ${response.status}: ${response.statusText}`);
        }
        const body = await response.text();
        return SoundFontPlayer.parse(body);
    }
    static parse(text) {
        let begin = text.indexOf('MIDI.Soundfont.');
        if (begin < 0)
            throw Error('Invalid MIDI.js Soundfont format');
        begin = text.indexOf('=', begin) + 2;
        const end = text.lastIndexOf(',');
        const json = `${text.slice(begin, end)}}`;
        return JSON.parse(json);
    }
}
function pitchDecoder(audioContext) {
    return async ([note, b64]) => {
        try {
            const buffer = await decodeBase64EncodedBuffer(audioContext, b64);
            return [Number(note), buffer];
        }
        catch (e) {
            throw new Error(`Cannot decode pitch ${note}: ${e}`);
        }
    };
}
//# sourceMappingURL=SoundFontPlayer.js.map